var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RequestCard',{attrs:{"data":_vm.data,"sectionId":_vm.sectionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }